import { render } from "./PrivilegesCatalogView.vue?vue&type=template&id=1f0095a0"
import script from "./PrivilegesCatalogView.vue?vue&type=script&lang=js"
export * from "./PrivilegesCatalogView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__